import { Component, OnInit } from '@angular/core';
import { StaticFileService } from '../static-file.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {

  constructor(public staticFileService: StaticFileService) { }

  ngOnInit() {
  }

}
